/* src/app/shared/invoice/retired/headers/retired-sa.css */
span {
  padding: .25em 0;
  display: inline-block;
}
/*# sourceMappingURL=retired-sa.css.map */
